import React, { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const BrandingCtx = createContext({ branding: null });

export function BrandingProvider({ children }) {
  const [branding, setBranding] = useState(null);
  useEffect(() => {
    api.get("/branding").then(({ data }) => {
      setBranding(data);
      if (data?.brand_name) document.title = data.brand_name;
      if (data?.primary_color) document.documentElement.style.setProperty("--brand-primary", data.primary_color);
    }).catch(() => {});
  }, []);
  return <BrandingCtx.Provider value={{ branding }}>{children}</BrandingCtx.Provider>;
}

export const useBranding = () => useContext(BrandingCtx);
